import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const isLoggedIn = !!localStorage.getItem("permissions");
  return isLoggedIn ? <Outlet /> : <Navigate to="/sign-in" replace />;
};

export default ProtectedRoutes;